<template>
  <transition v-if="view" name="modal">
    <div>
      <div class="modal-mask"></div>
      <div class="modal-container">
        <div class="modal-close">
          <img @click="$store.commit('modal/close')" src="/dist/btnClose.png" style="width: 20px;height: 20px">
        </div>
        <component :is="view"></component>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  computed: {
    view () {
      return this.$store.state.modal.view
    },
    value () {
      return this.$store.state.modal.value
    }
  },
  mounted () {
/*     document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        this.close()
      }
    }) */
  },
  methods: {
    close () {
      if (this.value) {
        const { done } = this.value
        done().stop()
      }
      this.$store.commit('modal/close')
    }
  }
};
</script>

<style>
.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #000000;
  opacity: 0.6;
  filter: alpha(opacity=60);
  z-index: 1;
}

.modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 400px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
  z-index: 2;
}

.modal-close {
  display: flex;
  flex-direction:row;
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;
  justify-content: flex-end;
  background:  #ffffff
}

.modal-close:hover {
  cursor: pointer
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/modal.vue